<template>
  <DialogWrapper
    close-on-cancel
    class="invite-apply-job-dialog"
    :show.sync="isShow"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title`"
    :saveBtnLabelI18nKey="`${i18nPrefix}.btn.invite`"
    @save="handleSave"
  >
    <WrappedForm
      ref="form"
      hideRequiredAsterisk
      :model="invitation"
      :formLines="formLines"
    >
      <template #jobSelector>
        <div class="job-selector">{{ `${job.id} - ${job.i18nName}` }}</div>
      </template>
    </WrappedForm>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    job: {
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.invitation.applyJob',
      invitation: { }
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    formLines () {
      const i18nPrefix = this.i18nPrefix
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        job: {
          label: this.$t(`${i18nPrefix}.label.job`),
          contentSlot: 'jobSelector'
        },
        subject: {
          label: this.$t(`${i18nPrefix}.label.subject`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        content: {
          label: this.$t(`${i18nPrefix}.label.content`),
          props: { type: 'textarea', autosize: { minRows: 5 } },
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        }
      }
      return lines
    },
    form () {
      return this.$refs.form
    }
  },
  created () {

  },
  methods: {
    async clearForm () {
      this.invitation = {}
      this.$nextTick(() => {
        this.form.clearValidate()
      })
    },
    async handleSave () {
      const isValid = await this.form.submit()
      if (!isValid) {
        return
      }
      this.$emit('save', this.invitation)
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-apply-job-dialog {
  .job-selector {
    min-height: 32px;
    padding: 6px 5px;
    border: 1px solid #c0c4cc;
    border-radius: 2px;
    line-height: normal;
    cursor: not-allowed;
    color: #bbbbbb;
  }
}
</style>
